import { Box, type SxProps } from "@mui/material";
import type { ReactNode } from "react";

export default function ContextualFooter({
  children,
}: {
  children: ReactNode | ReactNode[];
  sx?: SxProps;
  containerSx?: SxProps;
}) {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "var(--color-zinc-900)",
        color: "var(--color-zinc-400)",
        borderRadius: 1,
      }}
    >
      {children}
    </Box>
  );
}
